import { Component, OnInit, ViewChild } from '@angular/core';
import { UserControlCliService } from '../../core/services/user-control-cli.service';
import {
  ClientesControlCliModule, FiltroGruposControlCliModule, GrupoControlCliModule,
  FiltroUsuarioControlCliModule, UsuariosControlCliModule, Usuarios
} from '../../core/model/user-control-cli';
import { FormGroup, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Page } from '../../core/model/page';

@Component({
  selector: 'app-user-control-cli',
  templateUrl: './user-control-cli.component.html',
  styleUrls: ['./user-control-cli.component.css']
})
export class UserControlCliComponent implements OnInit {

  clientes: ClientesControlCliModule[] = [];

  gruposSeleccion: GrupoControlCliModule[] = [];
  grupoSeleccionado: number[];

  grupoCenterFind: GrupoControlCliModule[];

  textoFind: string;

  usuariosSeleccionados: UsuariosControlCliModule;
  contadorUsuariosSeleccionados = 0;
  usuario = '';
  email = '';
  loading = false;
  loadingGeneral = false;
  loadingSearch = false;

  selectedRow: any = undefined;
  selectedDir: any = undefined;

  @ViewChild('tblusers') table: any;
  @ViewChild('tbldirecciones') tabledirs: any;
  @ViewChild('tblmultis') tablemultis: any;

  page = new Page();

  constructor(
    public userCliService: UserControlCliService,
    private toastr: ToastrService
  ) {
    this.resetPagination();
  }

  ngOnInit() {
    this.initialize();
  }

  resetPagination() {
    this.page.pageNumber = 0;
    this.page.size = 10;
  }

  searchTagPromise = (term) => {
    this.loading = true;
    this.resetPagination();
    return new Promise((resolveProm) => {
      setTimeout(() => {
        this.userCliService.getGroups(new FiltroGruposControlCliModule(0, 0, term))
          .subscribe(
            (r) => {
              this.gruposSeleccion = r;
            },
            (e: Error) => {
              this.toastr.error('No se ha podido recuperar los grupos');
            },
            () => this.loading = false
          );
      }, 1000);
    });
  }

  addGroupCompl(idCentro: number) {
    this.loadingSearch = true;
    this.userCliService.addGroupCompl(this.selectedRow.Id, idCentro)
      .subscribe(p => {
        this.refreshGroupCompl();
        this.toastr.success('Se ha añadido correctamente el grupo como complementario al usuario');
      },
        (e: Error) => this.toastr.error('Ha ocurrido un error al añadir el acceso del grupo complementario al usuario. Detalles: ' + e.message),
        () => this.loadingSearch = false);
  }

  // 🐱‍👤 Busca a ver si el centro de entrada estuviera en el listado de centros que tiene el usuario
  // como complementario. Si es un 0 significa que no existe, 1 que existe como grupo complementario, 2 como centro perteneciente o derivado del SSO,
  // 3 es que no tiene acceso al cliente por SSO y 4 ya tiene acceso como administrador
  centerInCentersOfUser(centro: string, cliente: string): number {
    // Si el usuario tiene multiclient, el cliente no se encuentra dentro de éste o si no tiene multiclient y no pertenece a el, significa que no
    // tiene acceso al cliente
    if ((this.selectedRow.Multiclient !== undefined &&
      this.selectedRow.Multiclient !== null &&
      this.selectedRow.Multiclient.filter(p => p.Grupo.cliente.DESCRIPCION === cliente).length <= 0) ||
      ((this.selectedRow.Multiclient === undefined ||
        this.selectedRow.Multiclient === null) &&
        this.selectedRow.GROUP.cliente.DESCRIPCION !== cliente)) {
      return 3;
    }
    if (this.selectedRow !== undefined && this.selectedRow !== null &&
      this.selectedRow.UsuarioGrupoComplementario != undefined && this.selectedRow.UsuarioGrupoComplementario !== null &&
      this.selectedRow.UsuarioGrupoComplementario.filter(p => p.CENTRO === centro).length > 0) {
      return 1;
    } else if ( (this.selectedRow.GROUP !== undefined && this.selectedRow.GROUP.CENTRO === centro) ||
      (this.selectedRow !== undefined && this.selectedRow !== null &&
        this.selectedRow.Multiclient !== undefined && this.selectedRow.Multiclient !== null &&
        this.selectedRow.Multiclient.filter(p => p.CENTRO == centro).length > 0)) {
      return 2;
    } else if (
      (this.selectedRow.Multiclient !== undefined && this.selectedRow.Multiclient !== null &&
        this.selectedRow.Multiclient.filter(p => p.Grupo.cliente.DESCRIPCION === cliente && p.RANGO === 2).length > 0) ||
      (this.selectedRow.GROUP.CENTRO == centro && this.selectedRow.RANGO === 2)) {
      return 4;
    } else {
      return 0;
    }
  }

  findCenter(text: string) {
    if (text === undefined || text === null || text === '') {
      this.toastr.info('Debes indicar un número de centro a buscar');
      return;
    }
    this.loadingSearch = true;
    this.userCliService.getGroups(new FiltroGruposControlCliModule(0, 0, text))
      .subscribe(
        (r) => {
          if (r !== undefined && r !== null) {
            this.grupoCenterFind = r;
          }
        },
        (e: Error) => this.toastr.error('Ha ocurrido un error al buscar el centro, inténtelo de nuevo pasados unos minutos. Detalle: ' + e.message),
        () => this.loadingSearch = false
      );
  }

  resetGroupCompl() {
    this.userCliService.resetGroupCompl(this.selectedRow.Id)
      .subscribe(
        (r) => {
          this.toastr.success('Se han eliminado correctamente todos los accesos a los grupos');
          this.refreshGroupCompl();
        },
        (e: Error) => this.toastr.error('Ha ocurrido un error al resetear todos los permisos complementarios del usuario')
      );
  }

  private refreshGroupCompl() {
    this.userCliService.getGroupCompl(this.selectedRow.Id)
      .subscribe(
        (re) => this.selectedRow = re,
        (e: Error) => this.toastr.error('Ha ocurrido un error al actualizar los grupos complementarios a los que ' +
          'tiene acceso el usuario. Detalles: ' + e.message)
      );
  }

  deleteGroupCompl(idGroupCompl: number) {
    this.deleteGroup(idGroupCompl);
  }

  deleteGroupComplWithGrupo(idGrupo: number) {
    this.loadingSearch = true;
    this.userCliService.DeleteUserAccessComplWithGrupo(idGrupo)
      .subscribe(
        () => {
          this.toastr.success('Se ha eliminado satisfactoriamente el acceso al grupo');
          this.refreshGroupCompl();
        },
        (e: Error) => this.toastr.error('Ha ocurrido un error al eliminar el acceso al grupo. Detalles: ' + e.message),
        () => this.loadingSearch = false
      );
  }

  clearSearchCenterInUse() {
    this.grupoCenterFind = undefined;
    this.selectedRow = undefined;
  }

  private deleteGroup(idGroup: number) {
    this.userCliService.deleteGroupCompl(idGroup)
      .subscribe(
        (r) => {
          this.toastr.success('Se ha eliminado satisfactoriamente el acceso al grupo');
          this.refreshGroupCompl();
        },
        (e: Error) => this.toastr.error('Ha ocurrido un error al eliminar el acceso al grupo. Detalles: ' + e.message),
        () => this.loadingSearch = false
      );
  }

  initialize() {
    this.userCliService.getClients()
      .subscribe(
        (r: ClientesControlCliModule[]) => {
          this.clientes = r;
        }
      );
  }

  getGroupsClient(idCliente: number) {
    this.userCliService.getGroups(new FiltroGruposControlCliModule(idCliente = idCliente))
      .subscribe(
        (r: any) => {
          this.gruposSeleccion = r;
        }
      );
  }

  getUsersFilter(desde: number = 0, size: number = 10) {
    console.log(this.grupoSeleccionado);
    this.loadingGeneral = true;
    const filtro = new FiltroUsuarioControlCliModule(
      null,
      this.gruposSeleccion !== undefined && this.gruposSeleccion !== null && this.gruposSeleccion.length === 0
        ? null
        : this.grupoSeleccionado,
      null,
      this.usuario,
      this.email);
    this.userCliService.getUsuarios(filtro, desde, size)
      .subscribe(
        (r) => {
          this.resetPagination();
          this.usuariosSeleccionados = r;
          this.page.totalElements = r.contador;
        },
        (e: Error) => this.toastr.error('Ha ocurrido un error al cargar los usuarios según los filtros indicados'),
        () => this.loadingGeneral = false
      );
  }

  setPage($event) {
    this.getUsersFilter($event.offset * $event.pageSize, $event.pageSize);
    this.selectedRow = undefined;
    this.grupoCenterFind = [];
  }

  onResized($event) {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  onResizedDirs($event) {
    if (this.tabledirs) {
      setTimeout(() => {
        this.tabledirs.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  onResizedMultis($event) {
    if (this.tablemultis) {
      setTimeout(() => {
        this.tablemultis.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  activateRow($event) {
    if ($event.type == 'click') {
      this.selectedRow = $event.row;
    }
  }

  activateRowDirs($event) {
    if ($event.type == 'click') {
      this.selectedRow = $event.row;
    }
  }

  closeDetail() {
    this.selectedRow = undefined;
  }

  getRol(): string {
    if (this.selectedRow.SUPERVISOR) {
      return 'Supervisor';
    } else if (this.selectedRow.ADMINISTRADOR) {
      return 'Administrador';
    } else {
      return 'Operador';
    }
  }

  getRolRango(rango: any): string {
    console.log('Rango => ' + rango);
    switch (rango) {
      case '0':
        return 'Operador';
      case '1':
        return 'Supervisor';
      case '2':
        return 'Administrador';
    }
  }

  limpiarFiltros() {
    this.usuario = '';
    this.email = '';
    this.gruposSeleccion = [];
  }

}
